module.exports = __webpack_public_path__ + "img/success.c8aa46a5.png";